import { defineStore } from 'pinia'
import { reactive } from 'vue'

export const useDocumentTitlesStore = defineStore('document-titles', () => {
	/** Document title part per `TRoute` component.*/
	const map = reactive(new Map<symbol, string>())

	return { map }
})
